import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const STATUS_COLORS = {
  New: "linear-gradient(135deg, #2053c3, #63c7ff)",
  Completed: "linear-gradient(135deg, #0f9f6e, #5ce1c8)",
  Pending: "linear-gradient(135deg, #b8335b, #dc4d5b)",
  "Completed After Deadline": "linear-gradient(135deg, #b56a1b, #f0a33b)",
};

const ActionablesDashboard = () => {
  const [statusCounts, setStatusCounts] = useState({});
  const [username, setUsername] = useState(localStorage.getItem("username") || "");
  const navigate = useNavigate();

  useEffect(() => {
    if (!username) {
      const token = localStorage.getItem("accessToken");
      if (token) {
        axios
          .get("/api/users/me/", { headers: { Authorization: `Bearer ${token}` } })
          .then((res) => {
            const nextUsername = res.data.username;
            setUsername(nextUsername);
            localStorage.setItem("username", nextUsername);
          })
          .catch(() => {});
      }
    }
  }, [username]);

  useEffect(() => {
    if (!username) return;

    axios
      .post("/api/actionables/summary/", { username })
      .then((res) => {
        const counts = {};
        (res.data.pieData || []).forEach((item) => {
          counts[item.status] = item.count;
        });
        setStatusCounts(counts);
      })
      .catch((err) => console.error(err));
  }, [username]);

  return (
    <div className="page-shell">
      <section className="compact-hero">
        <div className="header-row" style={{ marginBottom: 0 }}>
          <div>
            <h1>Actionables Tracker</h1>
            <p>
              Choose a status to inspect its full register and move quickly into
              the underlying action items.
            </p>
          </div>
          <button className="secondary-btn" onClick={() => navigate("/dashboard")}>
            Back
          </button>
        </div>
      </section>

      <section className="metric-grid" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))" }}>
        {Object.keys(STATUS_COLORS).map((status) => (
          <button
            key={status}
            type="button"
            className="status-card"
            style={{ background: STATUS_COLORS[status], textAlign: "left" }}
            onClick={() => navigate(`/actionables/status/${status}`)}
          >
            <div style={{ position: "relative", zIndex: 1 }}>
              <div style={{ fontSize: "0.82rem", opacity: 0.82, textTransform: "uppercase", letterSpacing: "0.12em" }}>
                Status
              </div>
              <h3 style={{ margin: "12px 0 18px", fontSize: "1.28rem" }}>{status}</h3>
            </div>
          </button>
        ))}
      </section>
    </div>
  );
};

export default ActionablesDashboard;
